import angular from 'angular'

import movementCtrl from './movement.controller'
import movementRoutes from './movement.routes'
import movementRun from './movement.run'

const name = 'routingConsultMovement'

angular.module(name, [])
  .controller('movementCtrl', movementCtrl)
  .config(movementRoutes)
  .run(movementRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/movement/movement.module.js